/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import ImageIcon from '@material-ui/icons/Image';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DescriptionIcon from '@material-ui/icons/Description';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import FilePreviewDialog, { downloadFileDirect } from './FilePreviewDialog';

import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import ls from 'local-storage';
import AuthCheckComponent from '../../Layouts/Token';
import moment from 'moment';
import DdMmYyyyDateField from '../../../utils/DdMmYyyyDateField';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import WysiwygDescriptionEditor from './WysiwygDescriptionEditor';

import './TaskManagement.css';
import '../Leaves/Leave.css';
import '../Attendance/Attendance.css';
import './job.css';
import '../LeavesTicket/Ticket.css';

// Upload Icon matching user specification (Tray + Up Arrow)
const TrayUploadIcon = ({ size = 20, style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const AddProject = (props) => {
  const [formErrors, setFormErrors] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(true);

  const [projectData, setProjectData] = useState({
    project_name: '',
    start_date: '',
    target_date: '',
    description: '',
    member_ids: [],
  });

  // Sub Milestones state (matching CreateTask.js subTasks)
  const [subMilestones, setSubMilestones] = useState([]);
  const [newSubMilestoneTitle, setNewSubMilestoneTitle] = useState('');
  const [editingMilestoneIndex, setEditingMilestoneIndex] = useState(null);
  const [editSubMilestoneTitle, setEditSubMilestoneTitle] = useState('');

  const [activeUsers, setActiveUsers] = useState([]);

  // User popover state
  const [userPopoverAnchor, setUserPopoverAnchor] = useState(null);
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const avatarsScrollRef = useRef(null);

  // File attachments state (photos and all file types)
  const [projectFiles, setProjectFiles] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleAddSubMilestone = () => {
    if (editingMilestoneIndex !== null) return;
    const trimmed = (newSubMilestoneTitle || '').trim();
    if (!trimmed) return;
    setSubMilestones((prev) => [
      ...prev,
      {
        name: trimmed,
        status: 'Pending',
        details: trimmed,
      },
    ]);
    setNewSubMilestoneTitle('');
  };

  const handleDeleteSubMilestone = (index) => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this milestone?',
      icon: 'warning',
      buttons: ['Cancel', 'Yes'],
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        setSubMilestones((prev) => prev.filter((_, i) => i !== index));
        if (editingMilestoneIndex === index) {
          setEditingMilestoneIndex(null);
        }
      }
    });
  };

  const handleStartEditSubMilestone = (index) => {
    setEditingMilestoneIndex(index);
    setEditSubMilestoneTitle(subMilestones[index].name);
  };

  const handleSaveEditSubMilestone = (index) => {
    const trimmed = (editSubMilestoneTitle || '').trim();
    if (!trimmed) return;
    setSubMilestones((prev) =>
      prev.map((item, i) =>
        i === index
          ? { ...item, name: trimmed, details: trimmed }
          : item
      )
    );
    setEditingMilestoneIndex(null);
  };

  const handleCancelEditSubMilestone = () => {
    setEditingMilestoneIndex(null);
  };

  const isUserSuperAdmin = () => {
    try {
      const roles = ls.get('roles') || ls('roles');
      if (!roles) return false;
      const adminRoles = ['super admin', 'admin', 'administrator'];
      if (typeof roles === 'string') {
        const r = roles.trim().toLowerCase();
        return adminRoles.includes(r);
      }
      if (Array.isArray(roles)) {
        return roles.some((r) => {
          const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
          return adminRoles.includes(name);
        });
      }
      return false;
    } catch (_) {
      return false;
    }
  };

  useEffect(() => {
    if (!isUserSuperAdmin()) {
      swal('Access Denied', 'Only administrators can add projects.', 'warning');
      props.history.replace('/tasks');
      return;
    }
    fetchActiveUsers();
  }, []);

  // Horizontal scroll wheel for selected user avatars
  useEffect(() => {
    const el = avatarsScrollRef.current;
    if (!el) return;

    const handleWheel = (e) => {
      const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (delta !== 0) {
        e.preventDefault();
        e.stopPropagation();
        el.scrollBy({ left: Math.sign(delta) * 44, behavior: 'smooth' });
      }
    };

    el.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      el.removeEventListener('wheel', handleWheel);
    };
  }, [projectData.member_ids]);

  const fetchActiveUsers = async () => {
    try {
      setUsersLoading(true);
      const res = await AuthApi.getData();
      const users = (res && res.data) || [];
      const loggedActive = users.filter((u) => Number(u.user_logged) === 1);
      setActiveUsers(loggedActive);
    } catch (err) {
      console.error('Error fetching active users:', err);
    } finally {
      setUsersLoading(false);
    }
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .filter(Boolean)
      .map((part) => part[0].toUpperCase())
      .slice(0, 2)
      .join('');
  };

  // --- File Upload Handlers ---
  const handleFileSelect = (e) => {
    const selected = Array.from(e.target.files || []);
    if (selected.length > 0) {
      setProjectFiles((prev) => [...prev, ...selected]);
    }
    e.target.value = null;
  };

  const handleDownloadFile = (file) => {
    downloadFileDirect(file);
  };

  const handleViewFile = (file) => {
    if (!file) return;
    if (file instanceof File) {
      const blobUrl = window.URL.createObjectURL(file);
      setPreviewFile({
        url: blobUrl,
        name: file.name,
        type: file.type,
        size: file.size,
      });
    } else {
      setPreviewFile(file);
    }
  };

  const handleRemoveFile = (index) => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure you want to remove this file?',
      icon: 'warning',
      buttons: ['Cancel', 'Yes'],
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        setProjectFiles((prev) => prev.filter((_, i) => i !== index));
      }
    });
  };

  // --- Form Submit Handler ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    if (!projectData.project_name.trim()) {
      errors.project_name = 'Project name is required';
    }

    if (!projectData.member_ids || projectData.member_ids.length === 0) {
      errors.member_ids = 'User is required';
    }

    if (projectData.start_date) {
      const m = moment(projectData.start_date, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!m.isValid()) {
        errors.start_date = 'Please enter a valid start date (DD/MM/YYYY)';
      } else if (m.year() < 1900 || m.year() > 2099) {
        errors.start_date = 'Please enter a valid year (1900-2099)';
      }
    }

    if (projectData.target_date) {
      const m = moment(projectData.target_date, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!m.isValid()) {
        errors.target_date = 'Please enter a valid end date (DD/MM/YYYY)';
      } else if (m.year() < 1900 || m.year() > 2099) {
        errors.target_date = 'Please enter a valid year (1900-2099)';
      }
    }

    if (
      !errors.start_date &&
      !errors.target_date &&
      projectData.start_date &&
      projectData.target_date &&
      projectData.target_date < projectData.start_date
    ) {
      errors.target_date = 'End date cannot be before start date';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setSubmitLoading(true);
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });

    try {
      const memberIds = (projectData.member_ids || []).map(Number);

      const milestonesPayload = subMilestones.map((item) => {
        const text = (item.name || '').trim();
        return {
          name: text.length > 250 ? text.slice(0, 245) + '...' : text,
          description: text.length > 250 ? text.slice(0, 1000) : null,
          dueDate: null,
          status: item.status || 'Pending',
        };
      });

      const payload = {
        project_name: projectData.project_name.trim(),
        status: 0,
        summary: null,
        priority: 'No priority',
        start_date: projectData.start_date || null,
        target_date: projectData.target_date || null,
        description: (projectData.description || '').trim() || null,
        lead_id: memberIds.length > 0 ? memberIds[0] : null,
        lead_ids: memberIds,
        member_ids: memberIds,
        milestones: milestonesPayload,
      };

      const res = await AuthApi.createProject(payload);
      if (res && (res.status === true || res.status === 200 || res.success)) {
        const createdProjectId = (res.data && res.data.id) || res.id;

        // Upload any attached documents and photos
        if (createdProjectId && projectFiles.length > 0) {
          try {
            await Promise.all(
              projectFiles.map((file) =>
                AuthApi.uploadProjectResource(createdProjectId, file, file.name)
              )
            );
          } catch (uploadErr) {
            console.error('Error uploading project files:', uploadErr);
          }
        }

        swal.close();

        // Notifications: in-app project assignment notification
        const currentUserId = Number(props.authUser?.user?.id || ls('user')?.id || 0);
        const notifyIds = Array.from(
          new Set((Array.isArray(memberIds) ? memberIds : []).map(Number))
        ).filter((id) => !isNaN(id) && id > 0 && id !== currentUserId);
        const projectName = projectData.project_name.trim();

        // Send in-app notification to all assigned users (non-blocking)
        if (notifyIds.length > 0) {
          AuthApi.sendProjectNotification({
            userIds: notifyIds,
            projectName,
            projectId: createdProjectId || null,
            message: `You have been added to the project "${projectName}". Check your projects list for details.`,
          }).catch(() => {});
        }

        // Refresh notification bell
        try {
          window.dispatchEvent(new Event('cherrypik_refresh_notifications'));
        } catch (e) {}
        // --- End Notifications ---

        props.history.push('/manageproject');
        swal('Success', (res && res.message) || 'Project created successfully!', 'success');
      } else {
        swal.close();
        swal('Error', (res && res.message) || 'Failed to create project.', 'error');
      }
    } catch (err) {
      console.error('Error creating project:', err);
      swal.close();
      swal('Error', 'An unexpected error occurred while creating project.', 'error');
    } finally {
      setSubmitLoading(false);
    }
  };

  // pageLoading removed — form renders immediately; users load in background

  const isUsersSelected = (projectData.member_ids || []).length > 0;

  const pageContent = (
    <div style={{ marginBottom: '11%' }}>
      {/* Breadcrumb Card */}
      <div className="holiday-breadcrumb-card">
        <Breadcrumb
          {...props}
          primaryPageName="Tasks"
          primaryPageLink="/tasks"
          isSecondaryPage={true}
          secondaryPageName="Add Project"
        />
      </div>

      {/* Form Card */}
      <div className="holiday-form-card">
        <Typography
          variant="h2"
          className="holiday-form-title"
          style={{
            color: '#036dda',
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '20px',
          }}
        >
          Add Project
        </Typography>

        <form className="common-form-fields leave-ticket-form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={5}>
            {/* Project Name * */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                variant="outlined"
                id="project_name"
                name="project_name"
                label="Project name *"
                value={projectData.project_name}
                onChange={(e) => {
                  setProjectData({ ...projectData, project_name: e.target.value });
                  if (formErrors.project_name) {
                    setFormErrors((prev) => ({ ...prev, project_name: '' }));
                  }
                }}
                error={Boolean(formErrors.project_name)}
                className={formErrors.project_name ? "input-error" : ""}
              />
              {formErrors.project_name && (
                <span className="error">{formErrors.project_name}</span>
              )}
            </Grid>

            {/* Select User * */}
            <Grid item xs={12} sm={6}>
              <div style={{ position: 'relative' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="select_user"
                  name="select_user"
                  label="Select user *"
                  value={isUsersSelected ? " " : ""}
                  onClick={(e) => !usersLoading && setUserPopoverAnchor(e.currentTarget)}
                  error={Boolean(formErrors.member_ids)}
                  className={formErrors.member_ids ? "input-error" : ""}
                  InputLabelProps={{
                    shrink: isUsersSelected ? true : undefined,
                  }}
                  InputProps={{
                    readOnly: true,
                    style: {
                      cursor: usersLoading ? 'wait' : 'pointer',
                      padding: '0 14px',
                      height: '56px',
                      minHeight: '56px',
                      display: 'flex',
                      alignItems: 'center',
                    },
                    startAdornment: isUsersSelected ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: 'calc(100% - 28px)',
                          overflow: 'hidden',
                        }}
                      >
                        <span className="tm-selected-users-text">
                          {projectData.member_ids.length} user(s) selected
                        </span>

                        <div
                          ref={avatarsScrollRef}
                          className="tm-avatars-scroll"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            maxWidth: '100%',
                            padding: '2px 12px 2px 4px',
                            flex: 1,
                            marginRight: 6,
                          }}
                        >
                          {projectData.member_ids.map((uid) => {
                            const u = activeUsers.find((user) => Number(user.id) === Number(uid));
                            const name = u
                              ? (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name)
                              : `User #${uid}`;
                            return (
                              <Tooltip key={uid} title={name} arrow>
                                <Avatar
                                  src={u && u.photo ? u.photo : ''}
                                  style={{
                                    width: 32,
                                    height: 32,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    flexShrink: 0,
                                    backgroundColor: '#036dda',
                                    color: '#ffffff',
                                    border: '2px solid #ffffff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                  }}
                                >
                                  {getInitials(name)}
                                </Avatar>
                              </Tooltip>
                            );
                          })}
                        </div>
                      </div>
                    ) : null,
                    endAdornment: (
                      <InputAdornment position="end">
                        {usersLoading
                          ? <CircularProgress size={18} style={{ color: '#036dda' }} />
                          : <ExpandMoreIcon style={{ cursor: 'pointer', color: '#036dda' }} />
                        }
                      </InputAdornment>
                    ),
                    inputProps: {
                      readOnly: true,
                      style: {
                        cursor: 'pointer',
                        display: isUsersSelected ? 'none' : 'block',
                      },
                    },
                  }}
                />

                <Popover
                  open={Boolean(userPopoverAnchor)}
                  anchorEl={userPopoverAnchor}
                  onClose={() => {
                    setUserPopoverAnchor(null);
                    setUserSearchQuery('');
                  }}
                  disableScrollLock
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{
                    className: 'attendance-user-popover-paper',
                    style: {
                      width: 300,
                      marginTop: 5,
                      borderRadius: 8,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      backgroundColor: '#ffffff',
                    },
                  }}
                >
                  <Box p={1.5} className="attendance-user-popover-header">
                    <Typography
                      variant="subtitle2"
                      className="attendance-user-popover-title"
                      style={{
                        fontWeight: 700,
                        marginBottom: 8,
                        color: '#ffffff',
                      }}
                    >
                      Select User
                    </Typography>
                    <TextField
                      className="common-user-search-field"
                      fullWidth
                      size="small"
                      placeholder="Search users..."
                      variant="outlined"
                      value={userSearchQuery}
                      onChange={(e) => setUserSearchQuery(e.target.value)}
                      InputProps={{
                        style: {
                          backgroundColor: '#ffffff',
                          borderRadius: '4px',
                          height: '36px',
                        },
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" style={{ color: '#036dda' }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Divider />
                  <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                    <MenuItem
                      className={`attendance-user-option ${activeUsers.length > 0 && activeUsers.every((u) => (projectData.member_ids || []).map(Number).includes(Number(u.id))) ? 'attendance-user-selected' : ''}`}
                      selected={
                        activeUsers.length > 0 &&
                        activeUsers.every((u) =>
                          (projectData.member_ids || []).map(Number).includes(Number(u.id))
                        )
                      }
                      onClick={() => {
                        const allIds = activeUsers.map((u) => Number(u.id));
                        const isAllSelected =
                          allIds.length > 0 &&
                          allIds.every((id) =>
                            (projectData.member_ids || []).map(Number).includes(id)
                          );
                        const updated = isAllSelected ? [] : allIds;
                        setProjectData({
                          ...projectData,
                          member_ids: updated,
                        });
                        if (formErrors.member_ids && updated.length > 0) {
                          setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                        }
                      }}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: (activeUsers.length > 0 && activeUsers.every((u) => (projectData.member_ids || []).map(Number).includes(Number(u.id)))) ? '#036dda' : undefined,
                        color: (activeUsers.length > 0 && activeUsers.every((u) => (projectData.member_ids || []).map(Number).includes(Number(u.id)))) ? '#ffffff' : undefined,
                      }}
                    >
                      <ListItemText
                        primary="All Users"
                        primaryTypographyProps={{
                          style: {
                            color: (activeUsers.length > 0 && activeUsers.every((u) => (projectData.member_ids || []).map(Number).includes(Number(u.id)))) ? '#ffffff' : 'inherit',
                            fontWeight: (activeUsers.length > 0 && activeUsers.every((u) => (projectData.member_ids || []).map(Number).includes(Number(u.id)))) ? 600 : 400,
                          }
                        }}
                      />
                      {activeUsers.length > 0 &&
                        activeUsers.every((u) =>
                          (projectData.member_ids || []).map(Number).includes(Number(u.id))
                        ) && <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />}
                    </MenuItem>
                    {activeUsers
                      .filter((u) => {
                        const q = (userSearchQuery || '').toLowerCase();
                        const name = (
                          u.firstName ? `${u.firstName} ${u.lastName || ''}` : u.name || ''
                        ).toLowerCase();
                        return name.includes(q);
                      })
                      .map((user) => {
                        const displayName = user.firstName
                          ? `${user.firstName} ${user.lastName || ''}`.trim()
                          : user.name;
                        const isChecked = (projectData.member_ids || []).map(Number).includes(Number(user.id));
                        return (
                          <MenuItem
                            key={user.id}
                            className={`attendance-user-option ${isChecked ? 'attendance-user-selected' : ''}`}
                            selected={isChecked}
                            onClick={() => {
                              const current = (projectData.member_ids || []).map(Number);
                              const updated = isChecked
                                ? current.filter((id) => id !== Number(user.id))
                                : [...current, Number(user.id)];
                              setProjectData({
                                ...projectData,
                                member_ids: updated,
                              });
                              if (formErrors.member_ids && updated.length > 0) {
                                setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                              }
                            }}
                            style={{
                              padding: '8px 16px',
                              backgroundColor: isChecked ? '#036dda' : undefined,
                              color: isChecked ? '#ffffff' : undefined,
                            }}
                          >
                            <Box display="flex" alignItems="center" width="100%">
                              <Avatar
                                src={user.photo || ''}
                                style={{
                                  width: 32,
                                  height: 32,
                                  marginRight: 12,
                                  fontSize: '0.9rem',
                                  border: isChecked ? '2px solid #ffffff' : 'none',
                                }}
                              >
                                {getInitials(displayName)}
                              </Avatar>
                              <ListItemText
                                primary={displayName}
                                primaryTypographyProps={{
                                  style: {
                                    color: isChecked ? '#ffffff' : 'inherit',
                                    fontWeight: isChecked ? 600 : 400,
                                  }
                                }}
                              />
                              {isChecked && (
                                <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />
                              )}
                            </Box>
                          </MenuItem>
                        );
                      })}
                    {activeUsers.length === 0 && (
                      <div style={{ padding: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                        No active users found
                      </div>
                    )}
                  </div>
                </Popover>
              </div>
              {formErrors.member_ids && (
                <span className="error">{formErrors.member_ids}</span>
              )}
            </Grid>

            {/* Description (Rich Text WYSIWYG with Real Bold, Italic, Underline & Smart Bullets) */}
            <Grid item xs={12}>
              <WysiwygDescriptionEditor
                id="page_project_description"
                label="Description"
                placeholder="Enter project description..."
                value={projectData.description || ''}
                onChange={(html) => {
                  setProjectData({ ...projectData, description: html });
                  if (formErrors.description) {
                    setFormErrors((prev) => ({ ...prev, description: '' }));
                  }
                }}
                error={Boolean(formErrors.description)}
                helperText={formErrors.description}
                minHeight={120}
              />
            </Grid>

            {/* Start Date */}
            <Grid item xs={12} sm={6}>
              <DdMmYyyyDateField
                id="page_project_start_date"
                name="page_project_start_date"
                label="Start date"
                size="medium"
                value={projectData.start_date}
                error={Boolean(formErrors.start_date)}
                helperText={formErrors.start_date}
                onChange={(e) => {
                  const val = e.target.value;
                  setProjectData({ ...projectData, start_date: val });
                  if (val) {
                    const m = moment(val, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
                    if (!m.isValid()) {
                      setFormErrors((prev) => ({ ...prev, start_date: 'Please enter a valid start date (DD/MM/YYYY)' }));
                    } else if (m.year() < 1900 || m.year() > 2099) {
                      setFormErrors((prev) => ({ ...prev, start_date: 'Please enter a valid year (1900-2099)' }));
                    } else {
                      setFormErrors((prev) => ({ ...prev, start_date: '' }));
                    }
                  } else {
                    setFormErrors((prev) => ({ ...prev, start_date: '' }));
                  }
                  if (formErrors.target_date && (!val || !projectData.target_date || projectData.target_date >= val)) {
                    setFormErrors((prev) => ({ ...prev, target_date: '' }));
                  }
                }}
                max={projectData.target_date || undefined}
                className={formErrors.start_date ? "input-error" : ""}
              />
              {formErrors.start_date && (
                <span className="error">{formErrors.start_date}</span>
              )}
            </Grid>

            {/* End Date */}
            <Grid item xs={12} sm={6}>
              <DdMmYyyyDateField
                id="page_project_target_date"
                name="page_project_target_date"
                label="End date"
                size="medium"
                value={projectData.target_date}
                error={Boolean(formErrors.target_date)}
                helperText={formErrors.target_date}
                onChange={(e) => {
                  const val = e.target.value;
                  setProjectData({ ...projectData, target_date: val });
                  if (val) {
                    const m = moment(val, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
                    if (!m.isValid()) {
                      setFormErrors((prev) => ({ ...prev, target_date: 'Please enter a valid end date (DD/MM/YYYY)' }));
                    } else if (m.year() < 1900 || m.year() > 2099) {
                      setFormErrors((prev) => ({ ...prev, target_date: 'Please enter a valid year (1900-2099)' }));
                    } else if (projectData.start_date && val < projectData.start_date) {
                      setFormErrors((prev) => ({ ...prev, target_date: 'End date cannot be before start date' }));
                    } else {
                      setFormErrors((prev) => ({ ...prev, target_date: '' }));
                    }
                  } else {
                    setFormErrors((prev) => ({ ...prev, target_date: '' }));
                  }
                }}
                className={formErrors.target_date ? "input-error" : ""}
                min={projectData.start_date || undefined}
              />
              {formErrors.target_date && (
                <span className="error">{formErrors.target_date}</span>
              )}
            </Grid>

            {/* Document Upload (Photo and all type file upload) */}
            <Grid item xs={12}>
              <input
                type="file"
                ref={fileInputRef}
                id="project-files-input"
                multiple
                accept="image/*,.jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                style={{ display: 'none' }}
                onChange={handleFileSelect}
              />
              <TextField
                fullWidth
                variant="outlined"
                label="Document upload"
                value={
                  projectFiles.length > 0
                    ? `${projectFiles.length} file${projectFiles.length > 1 ? 's' : ''} attached`
                    : ''
                }
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                inputProps={{
                  readOnly: true,
                  style: {
                    cursor: 'pointer',
                    textOverflow: 'ellipsis',
                  },
                }}
                InputProps={{
                  style: {
                    cursor: 'pointer',
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="Upload documents or photos (All types supported)" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            fileInputRef.current && fileInputRef.current.click();
                          }}
                          className="tm-desc-upload-btn"
                          aria-label="Upload file"
                        >
                          <TrayUploadIcon size={21} style={{ color: '#036dda' }} />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Selected Files List */}
              {projectFiles.length > 0 && (
                <div
                  style={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    maxHeight: 180,
                    overflowY: 'auto',
                  }}
                >
                  {projectFiles.map((file, idx) => {
                    const fileName = file.name || (typeof file === 'string' ? file.split('/').pop() : `File ${idx + 1}`);
                    const isImg = (file.type && file.type.startsWith('image/')) || /\.(jpe?g|png|webp|gif|svg|jfif|ico|avif|bmp)$/i.test(fileName);
                    const isPdf =
                      file.type === 'application/pdf' || /\.pdf$/i.test(fileName);
                    const isWord =
                      /\.docx?$/i.test(fileName);
                    return (
                      <div key={idx} className="tm-selected-file-item">
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            overflow: 'hidden',
                            minWidth: 0,
                            flex: 1,
                          }}
                        >
                          {isImg ? (
                            <ImageIcon style={{ color: '#0284c7', fontSize: 18, flexShrink: 0 }} />
                          ) : isPdf ? (
                            <PictureAsPdfIcon style={{ color: '#ef4444', fontSize: 18, flexShrink: 0 }} />
                          ) : isWord ? (
                            <DescriptionIcon style={{ color: '#2563eb', fontSize: 18, flexShrink: 0 }} />
                          ) : (
                            <InsertDriveFileIcon style={{ color: '#64748b', fontSize: 18, flexShrink: 0 }} />
                          )}
                          <span
                            style={{
                              fontWeight: 500,
                              color: 'var(--tm-text)',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              fontSize: 12,
                            }}
                            title={fileName}
                          >
                            {fileName}
                          </span>
                          <span style={{ fontSize: 10, color: '#64748b', flexShrink: 0 }}>
                            ({(file.size / 1024).toFixed(0)}KB)
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                          <Tooltip title="View file" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewFile(file);
                              }}
                              style={{ color: '#036dda', padding: 3 }}
                            >
                              <VisibilityIcon style={{ fontSize: 17 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download file" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadFile(file);
                              }}
                              style={{ color: '#10b981', padding: 3 }}
                            >
                              <GetAppIcon style={{ fontSize: 17 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Remove file" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveFile(idx);
                              }}
                              style={{ color: '#94a3b8', padding: 3 }}
                            >
                              <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </Grid>

            {/* Milestone - Add Sub Milestone Accordion (Matching Add Sub Task in CreateTask.js) */}
            <Grid item xs={12}>
              <div style={{ width: '100%', border: '1px solid rgba(0, 0, 0, .125)', borderRadius: 4 }}>
                <Accordion elevation={0} style={{ background: 'transparent' }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{ color: '#036dda' }} />}
                    aria-controls="submilestone-accordion-content"
                    id="submilestone-accordion-header"
                    style={{ color: '#036dda', minHeight: 48 }}
                  >
                    <Typography
                      className="common-form-page-title"
                      style={{
                        color: 'var(--hrms-primary-blue-end, #036dda)',
                        fontSize: 15,
                        fontWeight: 400,
                      }}
                    >
                      Add Milestone
                      {subMilestones.length > 0 && (
                        <span style={{ fontSize: 13, fontWeight: 400, color: '#64748b', marginLeft: 8 }}>
                          ({subMilestones.length} added)
                        </span>
                      )}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ display: 'block', padding: '12px 16px 20px 16px' }}>
                    {/* Quick Add Bar */}
                    <div
                      className="tm-subtask-add-bar"
                      style={{
                        opacity: editingMilestoneIndex !== null ? 0.6 : 1,
                        transition: 'opacity 0.2s ease',
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Milestone Title"
                        placeholder={
                          editingMilestoneIndex !== null
                            ? 'Finish or cancel editing below first...'
                            : 'Type milestone title and press Enter...'
                        }
                        value={newSubMilestoneTitle}
                        onChange={(e) => setNewSubMilestoneTitle(e.target.value)}
                        disabled={editingMilestoneIndex !== null}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddSubMilestone();
                          }
                        }}
                        inputProps={{
                          style: {
                            fontWeight: 400,
                            fontSize: 14,
                          },
                        }}
                      />
                      <Button
                        type="button"
                        variant="contained"
                        disabled={editingMilestoneIndex !== null}
                        onClick={handleAddSubMilestone}
                        style={{
                          backgroundColor: editingMilestoneIndex !== null ? '#94a3b8' : '#036dda',
                          color: '#ffffff',
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: 14,
                          height: 40,
                          minWidth: 160,
                          padding: '0 20px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                          boxShadow: 'none',
                          cursor: editingMilestoneIndex !== null ? 'not-allowed' : 'pointer',
                        }}
                      >
                        Add Milestone
                      </Button>
                    </div>

                    {/* Sub Milestones List */}
                    {subMilestones.length > 0 ? (
                      <div className="tm-subtask-list">
                        {subMilestones.map((sub, index) => {
                          const isEditing = editingMilestoneIndex === index;

                          if (isEditing) {
                            return (
                              <div key={index} className="tm-subtask-row tm-subtask-row-edit">
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  label="Milestone Title"
                                  value={editSubMilestoneTitle}
                                  onChange={(e) => setEditSubMilestoneTitle(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleSaveEditSubMilestone(index);
                                    }
                                  }}
                                  style={{ background: '#ffffff', borderRadius: 4 }}
                                  inputProps={{
                                    style: {
                                      fontWeight: 400,
                                      fontSize: 14,
                                    },
                                  }}
                                />
                                <div className="tm-subtask-actions" style={{ gap: 8 }}>
                                  <Button
                                    type="button"
                                    size="small"
                                    variant="contained"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleSaveEditSubMilestone(index);
                                    }}
                                    style={{
                                      backgroundColor: '#036dda',
                                      color: '#ffffff',
                                      textTransform: 'none',
                                      fontWeight: 600,
                                      fontSize: 13,
                                      height: 38,
                                      minWidth: 80,
                                      padding: '0 18px',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      textAlign: 'center',
                                      lineHeight: 1,
                                      boxShadow: 'none',
                                    }}
                                  >
                                    Update
                                  </Button>
                                  <Button
                                    type="button"
                                    size="small"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleCancelEditSubMilestone();
                                    }}
                                    style={{
                                      backgroundColor: '#f1f5f9',
                                      color: '#475569',
                                      textTransform: 'none',
                                      fontWeight: 600,
                                      fontSize: 13,
                                      height: 38,
                                      minWidth: 80,
                                      padding: '0 18px',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      textAlign: 'center',
                                      lineHeight: 1,
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            );
                          }

                          return (
                            <div key={index} className="tm-subtask-row">
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
                                <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--tm-text, #1e293b)' }}>
                                  {sub.name}
                                </span>
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div className="tm-subtask-actions">
                                  <Tooltip title="Edit Milestone">
                                    <IconButton
                                      type="button"
                                      size="small"
                                      className="common-action-icon"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStartEditSubMilestone(index);
                                      }}
                                      style={{ padding: 6 }}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-edit"
                                        colorName="primary"
                                        fontSize="small"
                                      />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete Milestone">
                                    <IconButton
                                      type="button"
                                      size="small"
                                      className="common-action-icon"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleDeleteSubMilestone(index);
                                      }}
                                      style={{ padding: 6 }}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-trash"
                                        colorName="primary"
                                        fontSize="small"
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 13 }}>
                        No milestones added yet
                      </div>
                    )}
                  </AccordionDetails>
                </Accordion>
              </div>
            </Grid>
          </Grid>

          {/* Action Buttons (Save & Cancel matching AddTickets.js) */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} style={{ display: 'flex' }}>
              <Button
                type="submit"
                className="btn-success"
                style={{ marginTop: '10px', textTransform: 'none' }}
                variant="contained"
                color="primary"
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <>
                    <CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} />
                    Saving...
                  </>
                ) : (
                  'Save'
                )}
              </Button>
              <Button
                type="button"
                className="btn-cancel"
                style={{ marginTop: '10px', textTransform: 'none' }}
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push('/manageproject');
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={4}></Grid>
            <Grid item xs={12} sm={6} md={4}></Grid>
          </Grid>
        </form>
      </div>
    </div>
  );

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        setAutUser={props.setAutUser}
        component={pageContent}
      />
      <FilePreviewDialog
        open={Boolean(previewFile)}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
        onDownload={handleDownloadFile}
      />
      <Footer />
    </div>
  );
};

export default AddProject;
